var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiTagAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.88 15.7733L16.88 3.77333C16.3867 3.28 15.7067 3 15 3H5.66667C4.95942 3 4.28115 3.28095 3.78105 3.78105C3.28095 4.28115 3 4.95942 3 5.66667V15C3 15.7067 3.28 16.3867 3.78667 16.88L4.33333 17.4133C5.53333 16.6933 6.92 16.3333 8.33333 16.3333C10.4551 16.3333 12.4899 17.1762 13.9902 18.6765C15.4905 20.1768 16.3333 22.2116 16.3333 24.3333C16.3333 25.7467 15.96 27.12 15.24 28.3333L15.7733 28.8667C16.2667 29.3733 16.96 29.6667 17.6667 29.6667C18.3733 29.6667 19.0533 29.3867 19.5467 28.88L28.88 19.5467C29.3867 19.0533 29.6667 18.3733 29.6667 17.6667C29.6667 16.96 29.3867 16.28 28.88 15.7733ZM7.66667 9.66667C7.13623 9.66667 6.62753 9.45595 6.25245 9.08088C5.87738 8.70581 5.66667 8.1971 5.66667 7.66667C5.66667 7.13623 5.87738 6.62753 6.25245 6.25245C6.62753 5.87738 7.13623 5.66667 7.66667 5.66667C8.1971 5.66667 8.70581 5.87738 9.08088 6.25245C9.45595 6.62753 9.66667 7.13623 9.66667 7.66667C9.66667 8.1971 9.45595 8.70581 9.08088 9.08088C8.70581 9.45595 8.1971 9.66667 7.66667 9.66667ZM13.6667 25.6667H9.66667V29.6667H7V25.6667H3V23H7V19H9.66667V23H13.6667V25.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiTagAdd);
export default __webpack_public_path__ + "static/media/mdi_tag-add.ec8ca5da81d3d3b528f992cb10d3d11f.svg";
export { ForwardRef as ReactComponent };